import Group from '../entities/Group';
import Note from '../entities/Note';

const readNotesByGroup = (group: Group) => ({
  type: 'READ_NOTES_BY_GROUP',
  group
});

const successReadNotesByGroup = (notes: Note[]) => ({
  type: 'SUCCESS_READ_NOTES_BY_GROUP',
  notes
});

const readNotesDiff = () => ({
  type: 'READ_NOTES_DIFF'
});

const successReadNotesDiff = (notes: Note[]) => ({
  type: 'SUCCESS_READ_NOTES_DIFF',
  notes
});

const createNote = (note: Note) => ({
  type: 'CREATE_NOTE',
  note
});

const successCreateNote = (note: Note) => ({
  type: 'SUCCESS_CREATE_NOTE',
  note
});

const updateNote = (note: Note) => ({
  type: 'UPDATE_NOTE',
  note
});

const successUpdateNote = (note: Note) => ({
  type: 'SUCCESS_UPDATE_NOTE',
  note
});

const destroyNote = (note: Note) => ({
  type: 'DESTROY_NOTE',
  note
});

const successDestroyNote = (note: Note) => ({
  type: 'SUCCESS_DESTROY_NOTE',
  note
});

export {
  readNotesByGroup,
  successReadNotesByGroup,
  readNotesDiff,
  successReadNotesDiff,
  updateNote,
  successUpdateNote,
  destroyNote,
  successDestroyNote,
  createNote,
  successCreateNote
};



// WEBPACK FOOTER //
// ./src/actions/note.ts